import { render, staticRenderFns } from "./DepositDetailPopup.vue?vue&type=template&id=214dd545"
import script from "./DepositDetailPopup.vue?vue&type=script&lang=js"
export * from "./DepositDetailPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports